import React from "react";
import { Box } from "@mui/material";
import SupplierAwardList from "../../SupplierAwardList";
import PieChart from "../../PieChart";
import HorizontalBarChart from "../../HorizontalBarChart";
import StatusCardList from "../../StatusCardList";
import styles from "./analyticsDashboard.module.scss";

interface AnalyticsDashboardProps {
  awardBySuppliers?: any[];
  awardByCategory?: any[];
  awardByEntityUSD?: any[];
  awardByEntityPOCount?: any[];
  prByStatus?: any[];
}

const AnalyticsDashboard: React.FC<AnalyticsDashboardProps> = ({
  awardBySuppliers = [],
  awardByCategory = [],
  awardByEntityUSD = [],
  awardByEntityPOCount = [],
  prByStatus = [],
}) => {
  return (
    <>
      <Box className={styles.topSection}>
        <SupplierAwardList
          title="Award by Suppliers (USD)"
          data={awardBySuppliers}
          supplierKey="supplier"
          valueKey="value"
          poCountKey="poCount"
        />
        <PieChart
          title="Award by Category (USD)"
          data={awardByCategory}
          nameKey="category"
          valueKey="value"
          showPercentage={true}
        />
      </Box>

      <Box className={styles.middleSection}>
        <HorizontalBarChart
          title="Award by Entity (USD)"
          data={awardByEntityUSD}
          nameKey="entity"
          valueKey="value"
          barColor="#00d2aa"
          height={280}
        />
        <HorizontalBarChart
          title="Award by Entity (PO Count)"
          data={awardByEntityPOCount}
          nameKey="entity"
          valueKey="count"
          barColor="#5b6b9e"
          height={280}
        />
      </Box>

      <StatusCardList title="PR by Status" data={prByStatus} />
    </>
  );
};

export default AnalyticsDashboard;
